export default {"src":"/_next/static/media/company3.52026a59.svg","height":72,"width":72,"blurWidth":0,"blurHeight":0};